import axios from 'axios'

export const requestLogin = user => axios.post(`v1/auth/signin`, user)

export const requestLogout = () => axios.post(`v1/auth/logout`)